<template>
  <div class="client-list-container">
    <svg class="client-list-close-btn" @click="$emit('closeClientList')">
      <use xlink:href="static/mds/icons/mds.svg#remove">
        <title>Remove</title>
      </use>
    </svg>
    <ul>
      <li
        @click="$emit('updateClientFunds', 0, 'All Clients')"
        :class="[ isSelectedClient({ id: 0}) ? 'selected-client' : 'not-selected']"
      >
        All Clients
      </li>
      <li
        v-for="clientData in clientList"
        :key="clientData.id"
        :class="[ isSelectedClient(clientData) ? 'selected-client' : 'not-selected']"
        @click="
          $emit(
            'updateClientFunds',
            clientData.id,
            clientData.client.clientName,
            clientData.client.clientCode,
            clientData.hasReplacements
          )
        "
      >
        {{ clientData.client.clientName }}
      </li>
    </ul>
  </div>
</template>
<script>
import { uniqBy } from 'lodash';
import { getFiduciaryClients } from '@/services/FiduciaryClients';

export default {
  name: 'clientList',
  props: {
    fiduciary: {
      type: Number,
    },
    selectedClient: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      clientList: {},
    };
  },
  created() {
    getFiduciaryClients().then((result) => {
      if (result && result.status.success) {
        this.clientList = result.data.filter((client) => client.fiduciary.id === this.fiduciary);
        this.clientList = this.clientList.sort((a, b) => {
          if (a.client.clientName.toLowerCase() < b.client.clientName.toLowerCase()) {
            return -1;
          }
          if (a.client.clientName.toLowerCase() > b.client.clientName.toLowerCase()) {
            return 1;
          }
          return 0;
        });
        this.clientList = uniqBy(this.clientList, 'client.id');
        // saving the client list in the vuex store
        this.$store.dispatch('setClientList', this.clientList);
      }
    }).catch((error) => {
      const httpStatus = (error?.response.status) ? (error?.response.status) : error?.status;
      if (httpStatus === 401) {
        this.browseTo({ name: 'logout' });
      }
    });
  },
  methods: {
    browseTo(destination) {
      this.$router.push(destination);
    },
    isSelectedClient(client) {
      return this.selectedClient === client.id;
    },
  },
};
</script>
<style lang="scss">
.client-list {
  &-container {
    margin-left: 0;
    font-family: $mds-font-family-sans-serif;
    font-weight: $mds-font-weight-thin;
    font-size: $mds-font-size-m;
    line-height: $mds-space-4-x;
    padding: $mds-space-4-x;
    background-color: $mds-color-neutral-20;
    color: white;
    position: absolute;
    top: 60px;
    width: calc(100% - #{$mds-space-8-x});
    z-index: 9999;
    ul {
      margin: 0 auto;
      padding: 0;
      column-count: 4;
      list-style-type: none;
      li {
        cursor: pointer;
      }
    }

    .selected-client {
      opacity: 0.7;
    }
  }
  &-close-btn {
    position: absolute;
    top: 1em;
    right: 1em;
    width: 32px;
    height: 32px;
    fill: white;
  }
}
</style>
